<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">
              {{ id ? "Update" : "New" }} Access Profile
            </h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="name">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      formControlName="name"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('name')"
                    >
                      Name is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="custom-control custom-switch status-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!-- permisos para seleccionar mediante secciones por nombres -->
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Permisos</label>

                  <div class="row row__check" *ngFor="let perm of perms">
                    <div class="col-md-12">
                      <div
                        class="custom-control custom-checkbox status-check div__check mb-2 pb-4 pt-2 mt-4"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          [id]="perm.name"
                          [(ngModel)]="perm.status"
                          (change)="toggleModule(perm)"
                          name="perm-{{ perm.name }}"
                        />
                        <label
                          class="custom-control-label font-weight-bold"
                          [for]="perm.name"
                        >
                          <strong>{{ perm.name }}</strong>
                        </label>
                      </div>

                      <div class="ml-4 d-flex flex-wrap gap-3 pt-4 pb-4">
                        <div
                          class="custom-control custom-checkbox status-check mr-3"
                          *ngFor="let action of perm.actions"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            [id]="perm.name + '-' + action.name"
                            [(ngModel)]="action.status"
                            (change)="toggleAction(perm)"
                            name="perm-action-{{ perm.name }}-{{ action.name }}"
                          />
                          <label
                            class="custom-control-label label"
                            [for]="perm.name + '-' + action.name"
                          >
                            {{ action.name }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- permisos para seleccionar mediante lista desplegable por modulos individuales -->

            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Permissions</label>

                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="bmd-label-floating d-block"
                        >Select a module</label
                      >
                      <select
                        class="form-control select"
                        [(ngModel)]="selectedModuleName"
                        (ngModelChange)="onModuleChange($event)"
                      >
                        <option [ngValue]="null">Select</option>
                        <option *ngFor="let p of perms" [ngValue]="p.name">
                          {{ p.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div *ngIf="currentPerm">
                    <div
                      class="custom-control custom-checkbox status-check div__check mb-2 pb-2 pt-2 mt-2"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        [id]="'module-' + currentPerm.controller"
                        [(ngModel)]="currentPerm.status"
                        (change)="toggleModule(currentPerm)"
                        name="perm-{{ currentPerm.name }}"
                      />
                      <label
                        class="custom-control-label font-weight-bold"
                        [for]="'module-' + currentPerm.controller"
                      >
                        <strong>{{ currentPerm.name }}</strong>
                      </label>
                    </div>

                    <div class="ml-4 d-flex flex-wrap gap-3 pt-3 pb-3">
                      <div
                        class="custom-control custom-checkbox status-check mr-3"
                        *ngFor="
                          let action of currentPerm.actions;
                          let i = index
                        "
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          [id]="'action-' + currentPerm.controller + '-' + i"
                          [(ngModel)]="action.status"
                          (change)="toggleAction(currentPerm)"
                          name="perm-action-{{ currentPerm.name }}-{{
                            action.name
                          }}"
                        />
                        <label
                          class="custom-control-label label"
                          [for]="'action-' + currentPerm.controller + '-' + i"
                        >
                          {{ action.name }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="!currentPerm" class="text-muted">
                    Select a module to view and mark its actions.
                  </div>
                </div>
              </div>
            </div> -->

            <!-- permisos para seleccionar mediante lista desplegable por modulos asociados  -->

            <div class="row" *ngIf="id">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Permissions</label>
            
                  <!-- Selector de grupo -->
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="bmd-label-floating d-block">Select a group</label>
                      <select class="form-control select"
                              [(ngModel)]="selectedGroupLabel"
                              (ngModelChange)="onGroupChange($event)">
                        <option [ngValue]="null" disabled>Select</option>
                        <option *ngFor="let g of controllerGroups" [ngValue]="g.label">
                          {{ g.label }}
                        </option>
                      </select>
                    </div>
                  </div>
            
                  <!-- Contenido de todos los módulos del grupo -->
                  <ng-container *ngIf="currentPerms?.length; else noGroup">
                    <div class="mb-4 pb-2 pt-2"
                         *ngFor="let perm of currentPerms; trackBy: perm?.controller">
                      <!-- Título + switch maestro por módulo -->
                      <div class="custom-control custom-checkbox status-check div__check mb-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          [id]="'module-' + perm.controller"
                          [(ngModel)]="perm.status"
                          (change)="toggleModule(perm)"
                          name="perm-{{ perm.name }}"
                        />
                        <label
                          class="custom-control-label font-weight-bold"
                          [for]="'module-' + perm.controller">
                          <strong>{{ perm.name }}</strong>
                        </label>
                      </div>
            
                      <!-- Acciones del módulo -->
                      <div class="ml-4 d-flex flex-wrap gap-3 pt-2 pb-3">
                        <div class="custom-control custom-checkbox status-check mr-3"
                             *ngFor="let action of perm.actions; let i = index">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            [id]="'action-' + perm.controller + '-' + i"
                            [(ngModel)]="action.status"
                            (change)="toggleAction(perm)"
                            name="perm-action-{{ perm.name }}-{{ action.name }}"
                          />
                          <label class="custom-control-label label"
                                 [for]="'action-' + perm.controller + '-' + i">
                            {{ action.name }}
                          </label>
                        </div>
                      </div>
            
                      <hr class="mt-1 mb-3"/>
                    </div>
                  </ng-container>
            
                  <ng-template #noGroup>
                    <div class="text-muted">Selecciona un grupo para ver sus módulos</div>
                  </ng-template>
                </div>
              </div>
            </div>
            

            <button
              type="submit"
              class="btn btn-dark pull-right btn-create d-flex m-auto"
              [disabled]="form.invalid"
              (click)="onSubmit()"
            >
              {{ id ? "Update" : "Create" }}
            </button>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="card">
  <div class="card-header">
    <h3 class="card-title">{{ id ? "Editar" : "Nuevo" }} Rol</h3>
  </div>
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="name">Nombre</label>
        <input
          type="text"
          class="form-control"
          id="name"
          formControlName="name"
          [ngClass]="{ 'is-invalid': isFieldInvalid('name') }"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
          Name is required
        </div>
      </div>

      <div class="form-group">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            id="status"
            formControlName="status"
          />
          <label class="custom-control-label" for="status">Active</label>
        </div>
      </div>
      
      //permisos originales desde url 

      <div class="form-group">
        <label>permissions</label>
        <div class="row">
          <div class="col-md-4" *ngFor="let item of perms">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="item.url"
                [value]="item.url"
                (change)="onCheckChange($event)"
                [checked]="selectedPerms.includes(item.url)"
              />
              <label class="custom-control-label" [for]="item.url">{{
                item.name
              }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <button type="submit" class="btn btn-primary">Guardar</button>
        <a [routerLink]="['/administracion/roles/']" class="btn btn-default"
          >Cancelar</a
        >
      </div>
    </form>
  </div>
</div> -->
